<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="{{ symbologyText }}"
  width="25rem"
  height="auto"
  maxHeight="49rem"
  (onContentReady)="onContentReady()"
>
  <ng-template modalContent>
    <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
      <div class="form-content">
        <app-tree-list
          class="tree-list"
          [items]="treeItems"
          [openedSingleMode]="false"
        ></app-tree-list>

        <ng-template #pointFieldsTpl>
          <div class="fields-container" formGroupName="point">
            <div class="field-set">
              <label label>{{ sizeText }}</label>

              <app-input-box
                formControlName="size"
                type="number"
                [min]="1"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-box>
            </div>

            <div class="field-set">
              <label label>{{ colorText }}</label>

              <app-input-color-box
                formControlName="fillColor"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-color-box>
            </div>
          </div>
        </ng-template>

        <ng-template #lineFieldsTpl>
          <div class="fields-container" formGroupName="line">
            <div class="field-set">
              <label label>{{ thicknessText }}</label>

              <app-input-box
                formControlName="outlineWidth"
                type="number"
                [min]="1"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-box>
            </div>

            <div class="field-set">
              <label label>{{ colorText }}</label>

              <app-input-color-box
                formControlName="outlineColor"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-color-box>
            </div>
          </div>
        </ng-template>

        <ng-template #polygonFieldsTpl>
          <div class="fields-container" formGroupName="polygon">
            <div class="field-set">
              <label label>{{ thicknessText }}</label>

              <app-input-box
                formControlName="outlineWidth"
                type="number"
                [min]="1"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-box>
            </div>

            <div class="field-set">
              <label label>{{ outlineText }}</label>

              <app-input-color-box
                formControlName="outlineColor"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-color-box>
            </div>

            <div class="field-set">
              <label label>{{ fillText }}</label>

              <app-input-color-box
                formControlName="fillColor"
                [showErrorEnabled]="false"
                [showClearButton]="false"
              ></app-input-color-box>
            </div>
          </div>
        </ng-template>

        <div class="field-set">
          <label label>{{ transparencyText }}</label>

          <app-range-slider
            formControlName="opacity"
            [min]="0"
            [max]="1"
            [step]="0.01"
          ></app-range-slider>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          buttonType="normal"
          styleType="contained"
          text="{{ cancelText }}"
          (click)="onBtnCancelClick()"
        ></app-button>

        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="{{ applyText }}"
          [disabled]="formGroup.invalid"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
